import React from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";

const EMAIL_CARDS = [
    { title: "All Emails", link: "check-emails", icon: "bi-envelope-check", color: "blue", desc: "View configured accounts" },
    { title: "Email Templates", link: "email-templates", icon: "bi-file-earmark-text", color: "green", desc: "Manage country templates" },
    { title: "Email Validator", link: "validate-emails", icon: "bi-shield-check", color: "purple", desc: "Validate email lists" },
    { title: "Email Sender", link: "email-sender", icon: "bi-send", color: "orange", desc: "Bulk email campaigns" },
    { title: "Received Emails", link: "/incoming-emails", icon: "bi-inbox", color: "pink", desc: "Open inbox", external: true },
];

export default function Emails() {
    const getRole = Cookies.get("user_role");
    const getUsername = Cookies.get("username");

    if (getRole !== "Administrator") {
        return (
            <div className="container">
                <div className="crm-page-header">
                    <h1 className="crm-page-title">Access Denied</h1>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="crm-page-header">
                <h1 className="crm-page-title">Email Management</h1>
                <p className="crm-page-subtitle">Welcome, {getUsername} — manage your email tools</p>
            </div>

            <div className="crm-stat-grid">
                {EMAIL_CARDS.map((card) => (
                    <Link
                        key={card.title}
                        to={card.external ? card.link : `/emails/${card.link}`}
                        className="crm-stat-card"
                    >
                        <div className={`crm-stat-card-icon crm-stat-card-icon--${card.color}`}>
                            <i className={`bi ${card.icon}`}></i>
                        </div>
                        <div className="crm-stat-card-label">{card.title}</div>
                        <div className="crm-stat-card-value" style={{ fontSize: "0.95rem", fontWeight: 500 }}>
                            {card.desc}
                        </div>
                        <span className="crm-stat-card-link">
                            Open <i className="bi bi-arrow-right"></i>
                        </span>
                    </Link>
                ))}
            </div>
        </div>
    );
}
